export default __webpack_public_path__ + "static/media/footer_map.fad270be.png";